 $(document).ready(function(){
  $(document).on('change','.custom-options-selection input',function(){
   var dataOption = $(this).attr("data-index");
    var val = $(this).val();
  console.log(val);
  console.log(dataOption);
  var selval=  $(".options-selection input[data-index='"+dataOption+"']").val(val);
  if(! $(selval).is(":checked") ){ 
     //$(selval).prop("checked", true);
     //$(selval).parents("options-selection").find(".options-selection__option-name span").text(val);
    $(selval).trigger("click");
    }

   // var mselval= $("select.variant-selection__variants").find("option[data-var='"+val+"']").val();
    // $("select.variant-selection__variants").val(mselval).trigger("change");
  });

$(document).on('change','.options-selection input' ,function(){
    var dataOption = $(this).attr("data-index");
    var val = $(this).val();
   console.log(val);
   console.log(dataOption);
   var selval=  $(".custom-options-selection input[data-index='"+dataOption+"']").val(val);
   if(! $(selval).is(":checked") ){ 
     //$(selval).prop("checked", true);
     //$(selval).parents(".custom-options-selection").find(".options-selection__option-name span").text(val);
     $(selval).trigger("click");
    }
    
  
  });

  $(".product-stick-add-to-cart-container input.quantity").on("change", function(){
    console.log($(this).val());
    $(".main-qty input.quantity").val($(this).val());
  });
   
 $(".main-qty input.quantity").on("change", function(){
   console.log($(this).val());
    $(".product-stick-add-to-cart-container input.quantity").val($(this).val());
  });

$(".main-qty button.quantity--plus").on("click", function(){
    console.log($(this).siblings("input").val());
  var inVal = $(this).siblings("input").val();
    $(".product-stick-add-to-cart-container input.quantity").val(inVal);
  });
   
 $(".main-qty button.quantity--minus").on("click", function(){
   console.log($(this).siblings("input").val());
   var inVal = $(this).siblings("input").val();
    $(".product-stick-add-to-cart-container input.quantity").val(inVal);
  });
   
var getval = "";
  $(document).on('click', '.product-stick-add-to-cart-container button.quantity--plus', function(e){
     e.preventDefault()
     e.stopPropagation()
     var newQty = +($(this).siblings("input.quantity").val()) + 1;
     $(this).siblings("input").val(newQty);
     getval = newQty ;
     console.log(getval);
      $(".main-qty input.quantity").val(getval);
     $(this).siblings("button.quantity--minus").removeClass("disabled");
     $(this).siblings("button.quantity--minus").removeAttr("disabled", "disabled");  
    });
   
  $(document).on('click', '.product-stick-add-to-cart-container button.quantity--minus', function(e){
      e.preventDefault()
      e.stopPropagation()
      var newQty = +($(this).siblings("input.quantity").val()) - 1;
      if(newQty < 0)newQty = 0;
    if(newQty >= 1){
       $(this).siblings("input").val(newQty);
      getval = newQty ;
      console.log(getval);
      $(".main-qty input.quantity").val(getval);
    }
     
      if( getval == 1 )
      {
        $(this).attr("disabled", "disabled");
        $(this).addClass("disabled");
      }      
    });
   
   $(".product-stick-add-to-cart-container .product-form__cart-buttons button.add_to_cart").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    $(".main-add-cart").trigger("click");
  })
   
 });